export default __webpack_public_path__ + "static/media/pw-add-unit.bf7d0758.jpg";